/* ---------------- Types ---------------- */

type FilterOption = {
  key: string;
  label: string;
  days: number;
};

interface FilterDropdownProps {
  selected: number;
  onSelect: (days: number) => void;
}

/* ---------------- Component ---------------- */

export function FilterButtons({
  selected,
  onSelect
}: FilterDropdownProps) {
  const options: FilterOption[] = [
    { key: "3d", label: "Last 3 days", days: 3 },
    { key: "7d", label: "Last 7 days", days: 7 },
    { key: "14d", label: "Last 14 days", days: 14 }, // default
    { key: "30d", label: "Last 30 days", days: 30 },
    { key: "quarter", label: "Last Quarter", days: 90 },
    { key: "year", label: "Last Year", days: 365 }
  ];

  return (
    <select
      className="h-9 px-3 pr-8 rounded-md border border-gray-300 bg-white text-sm text-[#183853]
                focus:outline-none focus:ring-2 focus:ring-[#1E596D]"
      value={selected}
      onChange={(e) => onSelect(Number(e.target.value))}
    >
      {options.map((option) => (
        <option key={option.key} value={option.days}>
          {option.label}
        </option>
      ))}
    </select>
  );

}

